'use client';

import { useEffect, useRef, useState } from 'react';
import ReadingMode from './ReadingMode';

interface ReadingModeWrapperProps {
  title: string;
  url: string;
}

export default function ReadingModeWrapper({ title, url }: ReadingModeWrapperProps) {
  const [contentHtml, setContentHtml] = useState('');
  const extractedRef = useRef(false);

  useEffect(() => {
    if (extractedRef.current) return;
    // Extract article content from the prose container on the page
    const proseEl = document.querySelector('.prose');
    if (proseEl) {
      setContentHtml(proseEl.innerHTML);
      extractedRef.current = true;
    }
  }, []);

  if (!contentHtml) return null;

  return <ReadingMode title={title} contentHtml={contentHtml} url={url} />;
}
